(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carron-newsletter-popup"]) return;
  try {
    
  if (!customElements.get('carron-newsletter-popup')) {
    customElements.define('carron-newsletter-popup', class extends HTMLElement {
      connectedCallback() {
        if (this.started) return;
        this.started = true;
        this.panel = this.querySelector('.carron-newsletter');
        this.abort = new AbortController();
        this.screen = matchMedia('(min-width: 768px) and (hover: hover) and (pointer: fine)');
        this.key = 'carron:newsletter:';
        this.activeMs = 0;
        this.checked = false;
        const on = (target, name, callback) => target.addEventListener(name, callback, { signal: this.abort.signal });
        on(this.querySelector('.carron-newsletter__close'), 'click', () => this.close());
        on(this.panel, 'keydown', event => {
          if (event.key === 'Escape' && !event.defaultPrevented && !this.panel.hidden && !this.overlayOpen()) {
            event.preventDefault();
            event.stopPropagation();
            this.close();
          }
        });
        on(window, 'storage', () => { if (this.suppressed()) this.hide(); });
        on(window, 'pagehide', () => { clearInterval(this.timer); });
        on(window, 'pageshow', event => {
          if (!event.persisted) return;
          if (this.suppressed()) { this.hide(); return; }
          if (this.openRequested || (this.armed && !this.visit.shown)) { this.lastTick = performance.now(); this.startTimer(); }
        });
        on(this.screen, 'change', () => { if (!this.screen.matches) this.hide(); });
        on(this.querySelector('form'), 'submit', event => {
          const destination = new URL(location.href);
          destination.searchParams.set('customer_posted', 'true');
          destination.hash = 'carron-newsletter-result';
          const returnTo = event.currentTarget.elements.namedItem('return_to');
          if (returnTo) returnTo.value = destination.pathname + destination.search + destination.hash;
          this.write('sessionStorage', 'pending', String(Date.now()));
          this.track('submit');
        });
        const pending = Number(this.read('sessionStorage', 'pending'));
        const recentSubmission = pending > 0 && Date.now() - pending >= 0 && Date.now() - pending < 1800000;
        if (this.querySelector('[data-newsletter-success]')) {
          this.write('localStorage', 'subscribed', 'true');
          if (recentSubmission) {
            this.write('sessionStorage', 'pending', '0');
            this.track('success');
            if (this.screen.matches) this.show(false);
          }
          return;
        }
        if (this.querySelector('[data-newsletter-errors]') && recentSubmission && this.screen.matches) {
          this.show(false);
          return;
        }
        if (this.dataset.designMode === 'true') { if (this.screen.matches) this.show(false); return; }
        if (this.dataset.eligible !== 'true' || this.hasConfigurator() || !this.screen.matches || this.suppressed()) return;
        let visit;
        try { visit = JSON.parse(this.read('sessionStorage', 'visit') || 'null'); } catch { visit = null; }
        if (!visit || !Array.isArray(visit.pages) || Date.now() - visit.last > 1800000) visit = { pages: [], last: Date.now(), shown: false };
        const root = this.dataset.root.replace(/\/$/, '');
        const path = location.pathname.slice(root.length).replace(/\/$/, '') || '/';
        if (!visit.pages.includes(path)) visit.pages.push(path);
        visit.last = Date.now();
        this.visit = visit;
        if (!this.write('sessionStorage', 'visit', JSON.stringify(visit)) || visit.shown || visit.pages.length < Number(this.dataset.pages)) return;
        this.armed = true;
        this.lastTick = performance.now();
        this.startTimer();
      }
      disconnectedCallback() { clearInterval(this.timer); this.abort?.abort(); }
      read(storage, name) { try { return window[storage].getItem(this.key + name); } catch { return null; } }
      write(storage, name, value) { try { window[storage].setItem(this.key + name, value); return true; } catch { return false; } }
      suppressed() {
        try {
          return this.read('localStorage', 'subscribed') === 'true' || Number(this.read('localStorage', 'dismissedUntil')) > Date.now() || ['9548-dismissed-after-submit', '91903-dismissed-after-submit', 'theme:popup-filled'].some(key => localStorage.getItem(key));
        } catch { return true; }
      }
      hasConfigurator() { return !!document.querySelector('[data-cfg2], .nn-mais, table-composer'); }
      overlayOpen() {
        return [...document.querySelectorAll('dialog[open], [role="dialog"], [aria-modal="true"], .pswp--open, .drawer[open], #shopify-pc__banner, .shopify-pc__banner__dialog')].some(element => !this.contains(element) && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden');
      }
      busy() {
        return document.hidden || !this.screen.matches || document.activeElement?.matches('input,textarea,select,[contenteditable="true"]') || this.overlayOpen();
      }
      startTimer() { clearInterval(this.timer); this.timer = setInterval(() => this.tick(), 250); }
      async tick() {
        const now = performance.now();
        const elapsed = Math.min(now - this.lastTick, 1000);
        this.lastTick = now;
        if (this.openRequested) {
          if (this.overlayOpen()) {
            this.restoreFocus();
            this.panel.hidden = true;
            this.resumeAfter = now + 5000;
          } else if (this.panel.hidden && !this.busy() && now >= (this.resumeAfter || 0)) {
            this.panel.setAttribute('data-resumed', '');
            this.panel.hidden = false;
            this.announce();
          }
          return;
        }
        if (!document.hidden) this.activeMs += elapsed;
        if (this.busy()) { this.quietAfter = now + 5000; return; }
        if (this.checked || this.activeMs < Number(this.dataset.delay) * 1000 || now < (this.quietAfter || 0)) return;
        if (this.hasConfigurator()) { clearInterval(this.timer); return; }
        if (this.suppressed()) { clearInterval(this.timer); return; }
        this.checked = true;
        let allowed = this.dataset.customer === 'anonymous';
        if (!allowed) {
          try {
            const response = await fetch(this.dataset.root.replace(/\/$/, '') + '/apps/loyalty/newsletter-eligibility', { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(5000) });
            allowed = response.ok && (await response.json()).eligible === true;
          } catch { allowed = false; }
        }
        if (!allowed) { clearInterval(this.timer); return; }
        if (this.busy()) { this.checked = false; this.quietAfter = performance.now() + 5000; return; }
        if (this.suppressed()) { clearInterval(this.timer); return; }
        clearInterval(this.timer);
        this.visit.shown = true;
        this.visit.last = Date.now();
        this.write('sessionStorage', 'visit', JSON.stringify(this.visit));
        this.show(true);
      }
      show(measure) {
        this.returnFocus = document.activeElement;
        this.openRequested = true;
        const picture = this.querySelector('[data-image]');
        if (picture.dataset.image) picture.style.backgroundImage = `url("${picture.dataset.image}")`;
        this.panel.hidden = this.overlayOpen();
        if (this.panel.hidden) this.resumeAfter = performance.now() + 5000;
        if (!this.panel.hidden) this.announce();
        this.lastTick = performance.now();
        this.startTimer();
        if (measure) this.track('view');
      }
      announce() {
        const announcement = this.querySelector('[data-newsletter-announcement]');
        if (announcement) announcement.textContent = this.querySelector('[data-newsletter-success]')?.textContent.trim() || announcement.dataset.message;
      }
      restoreFocus() {
        if (!this.panel.contains(document.activeElement)) return;
        let target = this.returnFocus;
        if (!target?.isConnected || target === document.body || this.contains(target) || target.getClientRects().length === 0) target = document.querySelector('main');
        if (!target) return;
        const temporaryTabindex = !target.hasAttribute('tabindex') && !target.matches('a[href],button,input,select,textarea');
        if (temporaryTabindex) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
        if (temporaryTabindex) target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
      }
      hide() {
        this.restoreFocus();
        this.openRequested = false;
        this.panel.hidden = true;
        clearInterval(this.timer);
      }
      close() {
        this.hide();
        this.write('localStorage', 'dismissedUntil', String(Date.now() + Number(this.dataset.cooldown) * 86400000));
        this.track('close');
      }
      track(action) {
        if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) {
          try { Promise.resolve(window.Shopify.analytics?.publish?.('carron_newsletter_' + action, { source: 'popup_native' })).catch(() => {}); } catch {}
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carron-wholesale-preorder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const parseJson = (value, fallback) => {
      try {
        return JSON.parse(value);
      } catch (_error) {
        return fallback;
      }
    };

    const roundMoney = (value) => Math.round(value * 100) / 100;
    const normalizeSearch = (value, locale) =>
      String(value || '')
        .replace(/œ/gi, 'oe')
        .replace(/æ/gi, 'ae')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLocaleLowerCase(locale || 'en');

    const observedSections = new WeakSet();
    const catalogueRequestCache = new Map();
    const basketRequestCache = new Map();
    const cachedRequest = (cache, key, requestFactory) => {
      if (cache.has(key)) return cache.get(key);
      const request = requestFactory().catch((error) => {
        cache.delete(key);
        throw error;
      });
      cache.set(key, request);
      return request;
    };
    const closeDesktopFacets = (scope) => {
      scope
        .querySelectorAll('.carron-preorder__filter-form--desktop .carron-preorder__facet[open]')
        .forEach((facet) => {
          facet.open = false;
        });
    };
    const observeSection = (root) => {
      const wrapper = root.closest('.shopify-section');
      if (!wrapper || observedSections.has(wrapper)) return;
      observedSections.add(wrapper);
      new MutationObserver(() => initializeAll(wrapper)).observe(wrapper, { childList: true });
    };

    const initialize = (root) => {
      if (root.dataset.mounted === 'true') return;
      root.dataset.mounted = 'true';
      observeSection(root);
      closeDesktopFacets(root);

      const isInStock = root.dataset.catalogueMode === 'instock';
      const basketRequestUrl = new URL(root.dataset.basketUrl, window.location.origin);
      const basketRequestKey = basketRequestUrl.toString();
      const basketStorageKey = `carron-wholesale-preorder-v1-${root.dataset.customerId}`;
      const submissionStorageKey = `carron-wholesale-preorder-submission-v1-${root.dataset.customerId}`;

      const copy = parseJson(root.querySelector('[data-wholesale-copy]')?.textContent || '{}', {});
      const status = root.querySelector('[data-wholesale-status]');
      const content = root.querySelector('[data-wholesale-content]');
      const total = root.querySelector('[data-wholesale-total]');
      const minimumStatus = root.querySelector('[data-wholesale-minimum-status]');
      const minimumProgress = root.querySelector('[data-wholesale-minimum-progress]');
      const basketElement = root.querySelector('[data-wholesale-basket]');
      const basketPriceTooltip = root.querySelector('[data-basket-price-tooltip]');
      if (basketPriceTooltip) {
        const staleTooltip = document.body.querySelector(`#${CSS.escape(basketPriceTooltip.id)}`);
        if (staleTooltip && staleTooltip !== basketPriceTooltip) staleTooltip.remove();
        document.body.append(basketPriceTooltip);
      }
      const feedback = root.querySelector('[data-wholesale-feedback]');
      const saved = root.querySelector('[data-wholesale-saved]');
      const savedIndicator = root.querySelector('[data-wholesale-saved-indicator]');
      const savedTooltip = root.querySelector('[data-wholesale-saved-tooltip]');
      const submitButton = root.querySelector('[data-wholesale-submit]');
      const rrpAcknowledgement = root.querySelector('[name="rrp_policy_acknowledgement"]');
      const pricelistLink = root.querySelector('[data-wholesale-pricelist]');
      const clearButton = root.querySelector('[data-wholesale-clear]');
      const search = root.querySelector('[data-wholesale-search]');
      const searchClear = root.querySelector('[data-wholesale-search-clear]');
      const searchResults = root.querySelector('[data-wholesale-search-results]');
      const resultCount = root.querySelector('[data-wholesale-result-count]');
      const inStockNoResults = root.querySelector('[data-instock-no-results]');
      const lightbox = root.querySelector('[data-wholesale-lightbox]');
      const lightboxImage = root.querySelector('[data-wholesale-lightbox-image]');
      const confirmation = root.querySelector('[data-wholesale-confirmation]');
      const confirmationMessage = root.querySelector('[data-wholesale-confirmation-message]');
      const confirmationClose = root.querySelector('[data-wholesale-confirmation-close]');
      const indicativeNote = root.querySelector('[data-wholesale-indicative-note]');
      const productDetailsDrawer = root.querySelector('[data-product-details-drawer]');
      const conditionMinimums = [...root.querySelectorAll('[data-wholesale-condition-minimum]')];
      const totalMirror = root.querySelector('[data-wholesale-total-mirror]');
      const statusMirror = root.querySelector('[data-wholesale-status-mirror]');
      const productRows = [...root.querySelectorAll('[data-product-row]')];
      const variantRows = [...root.querySelectorAll('[data-variant-row]')];
      const proAlerts = root.querySelector('carron-pro-stock-alerts');
      let hideUnavailable = true;
      const priceByVariant = new Map();
      const stockByProduct = new Map();
      let pricing = null;
      let locked = false;
      let basket = {};
      let localBasketUpdatedAt = 0;
      let localBasketHasTimestamp = false;
      let basketDigest = null;
      let basketSyncReady = false;
      let basketSaveTimer = null;
      let basketSyncing = false;
      let basketSyncPending = false;
      let cartHasPriceMismatch = false;
      let cartHasUnsupportedItems = false;
      let cartPriceMismatchProducts = [];

      confirmationClose?.addEventListener('click', () => confirmation?.close());

      const openConfirmation = (draftOrderName) => {
        if (!confirmation || !confirmationMessage) return;
        confirmationMessage.textContent = copy.created.replace('__NAME__', draftOrderName);
        if (typeof confirmation.showModal === 'function') {
          confirmation.showModal();
          return;
        }
        confirmation.setAttribute('open', '');
        confirmationClose?.focus();
      };
      let cartValidationIssues = [];
      let searchTargetTimer = null;
      let basketPriceTooltipTimer = null;

      const hideBasketPriceTooltip = () => {
        if (!basketPriceTooltip) return;
        window.clearTimeout(basketPriceTooltipTimer);
        basketPriceTooltip.style.opacity = '0';
        basketPriceTooltipTimer = window.setTimeout(() => {
          basketPriceTooltip.hidden = true;
        }, 120);
      };

      const showBasketPriceTooltip = (trigger) => {
        const tooltipText = trigger.dataset.tooltip;
        if (!basketPriceTooltip || !tooltipText) return;
        window.clearTimeout(basketPriceTooltipTimer);
        basketPriceTooltip.textContent = tooltipText;
        basketPriceTooltip.hidden = false;
        basketPriceTooltip.style.opacity = '0';
        basketPriceTooltip.style.visibility = 'hidden';
        const triggerRect = trigger.getBoundingClientRect();
        const tooltipRect = basketPriceTooltip.getBoundingClientRect();
        const left = Math.min(
          window.innerWidth - tooltipRect.width - 12,
          Math.max(12, triggerRect.left)
        );
        const below = triggerRect.bottom + 8;
        const top =
          below + tooltipRect.height <= window.innerHeight - 12
            ? below
            : Math.max(12, triggerRect.top - tooltipRect.height - 8);
        basketPriceTooltip.style.left = `${left}px`;
        basketPriceTooltip.style.top = `${top}px`;
        basketPriceTooltip.style.visibility = '';
        window.requestAnimationFrame(() => {
          basketPriceTooltip.style.opacity = '1';
        });
      };

      const bindPriceStatusTooltip = (priceStatus, tooltipText) => {
        if (!basketPriceTooltip || !tooltipText) return;
        priceStatus.dataset.tooltip = tooltipText;
        priceStatus.tabIndex = 0;
        priceStatus.setAttribute('aria-describedby', basketPriceTooltip.id);
        priceStatus.addEventListener('pointerenter', () => showBasketPriceTooltip(priceStatus));
        priceStatus.addEventListener('pointerleave', () => {
          if (document.activeElement !== priceStatus) hideBasketPriceTooltip();
        });
        priceStatus.addEventListener('focus', () => showBasketPriceTooltip(priceStatus));
        priceStatus.addEventListener('blur', hideBasketPriceTooltip);
      };

      const setSavedStatus = (message, state) => {
        saved.textContent = message;
        if (savedTooltip) savedTooltip.textContent = message;
        if (savedIndicator) {
          savedIndicator.dataset.state = state;
          savedIndicator.setAttribute('aria-label', message);
        }
      };

      const initialUrl = new URL(window.location.href);
      const isAlertLink = ['fr', 'en'].includes(initialUrl.searchParams.get('carron_alert_lang'));
      const alertVariantId = isInStock && isAlertLink ? window.CarronAlertLinks?.variantId(initialUrl.href) : null;
      const alertTargetRow = alertVariantId ? variantRows.find((row) => row.dataset.variantId === alertVariantId) : null;
      const locateAlertTarget = alertVariantId && !alertTargetRow && !initialUrl.searchParams.has('carron_alert_page');
      if (isAlertLink) {
        root.addEventListener('facet:update', (event) => {
          event.detail.url = window.CarronAlertLinks.browseUrl(event.detail.url.href);
        });
      }
      const initialSearchQuery = initialUrl.searchParams.get('q') || '';
      const reviewCheckout = isInStock && initialUrl.searchParams.get('checkout') === 'review';
      if (initialSearchQuery) search.value = initialSearchQuery;
      if (!isInStock) {
        try {
          const stored = parseJson(localStorage.getItem(basketStorageKey) || '{}', {});
          if (
            stored?.version === 2 &&
            stored.basket &&
            typeof stored.basket === 'object' &&
            !Array.isArray(stored.basket)
          ) {
            basket = stored.basket;
            localBasketUpdatedAt = Date.parse(stored.updatedAt || '') || 0;
            localBasketHasTimestamp = localBasketUpdatedAt > 0;
          } else if (stored && typeof stored === 'object' && !Array.isArray(stored)) {
            basket = stored;
          }
          setSavedStatus(copy.savedLocal, 'saving');
        } catch (_error) {
          setSavedStatus(copy.saveUnavailable, 'error');
        }
      }

      const moneyInCurrency = (value, currency) => {
        try {
          return new Intl.NumberFormat(root.dataset.locale || 'en', {
            style: 'currency',
            currency,
          }).format(value);
        } catch (_error) {
          return '';
        }
      };
      const formatPreorderEur = (value) => moneyInCurrency(value, 'EUR');
      const formatInStockMoney = (value) =>
        moneyInCurrency(value, root.dataset.currency || 'EUR');
      const money = (value) =>
        isInStock ? formatInStockMoney(value) : formatPreorderEur(value);
      const roundDownCommercialMinimum = (value) => {
        if (!Number.isFinite(value) || value <= 0) return 0;
        const step = 5 * (10 ** Math.max(0, Math.floor(Math.log10(value)) - 2));
        return Math.floor((value / step) + 1e-9) * step;
      };
      const inStockOrderMinimum = () => {
        const minimumEur = Number(pricing?.orderMinimumEur) || 0;
        const currencyRate = Number(window.Shopify?.currency?.rate);
        return roundDownCommercialMinimum(
          minimumEur * (Number.isFinite(currencyRate) && currencyRate > 0 ? currencyRate : 1),
        );
      };
      const indicativeMoney = (value, currency) => {
        try {
          return new Intl.NumberFormat(root.dataset.locale || 'en', {
            style: 'currency',
            currency,
            currencyDisplay: 'code',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          }).format(value);
        } catch (_error) {
          return '';
        }
      };
      const approximatePreorderMoney = (value) => {
        const currency = root.dataset.currency || 'EUR';
        const currencyRate = Number(window.Shopify?.currency?.rate);
        if (
          isInStock ||
          currency === 'EUR' ||
          !Number.isFinite(value) ||
          !Number.isFinite(currencyRate) ||
          currencyRate <= 0
        ) {
          return '';
        }
        return indicativeMoney(Math.ceil(value * currencyRate), currency);
      };
      const setDisplayedTotal = (value) => {
        const formattedIndicative = approximatePreorderMoney(value);
        total.textContent = `${money(value)}${formattedIndicative ? ` (≈ ${formattedIndicative})` : ''}`;
        if (totalMirror) totalMirror.textContent = total.textContent;
      };

      const openImage = (imageUrl, imageAlt) => {
        if (!imageUrl || !lightbox || !lightboxImage) return;
        lightboxImage.src = imageUrl;
        lightboxImage.alt = imageAlt || '';
        if (typeof lightbox.showModal === 'function') {
          lightbox.showModal();
        } else {
          lightbox.setAttribute('open', '');
        }
      };

      const closeImage = () => {
        if (!lightbox) return;
        if (typeof lightbox.close === 'function') {
          lightbox.close();
        } else {
          lightbox.removeAttribute('open');
        }
        lightboxImage?.removeAttribute('src');
      };

      const handleLightboxEscape = (event) => {
        if (!root.isConnected) {
          window.removeEventListener('keydown', handleLightboxEscape, true);
          return;
        }
        if (event.key !== 'Escape' || !lightbox?.hasAttribute('open')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        closeImage();
      };
      window.addEventListener('keydown', handleLightboxEscape, true);

      const handleImageOpen = (event) => {
        const button = event.target instanceof Element
          ? event.target.closest('[data-image-open]')
          : null;
        if (
          !button ||
          (!root.contains(button) && !productDetailsDrawer?.contains(button))
        ) return;
        event.preventDefault();
        event.stopPropagation();
        openImage(button.dataset.imageUrl, button.dataset.imageAlt);
      };
      root.addEventListener('click', handleImageOpen, true);
      productDetailsDrawer?.addEventListener('click', handleImageOpen, true);
      root.querySelector('[data-image-close]')?.addEventListener('click', closeImage);
      lightbox?.addEventListener('click', (event) => {
        if (event.target === lightbox) closeImage();
      });

      const productDetailsCache = new Map();
      let productDetailsRequest = 0;
      const showDetailsMessage = (message) => {
        if (!productDetailsDrawer) return;
        const element = document.createElement('p');
        element.className = 'carron-product-details__message';
        element.textContent = message;
        productDetailsDrawer.replaceChildren(element);
      };
      const showDetailsHtml = (html) => {
        if (!productDetailsDrawer) return;
        const template = document.createElement('template');
        template.innerHTML = html.trim();
        productDetailsDrawer.replaceChildren(template.content.cloneNode(true));
      };
      const openProductDetails = async (button) => {
        if (!productDetailsDrawer || !button.dataset.productUrl) return;
        const productUrl = new URL(button.dataset.productUrl, window.location.origin);
        const cacheKey = productUrl.pathname;
        const cached = productDetailsCache.get(cacheKey);
        if (cached) {
          showDetailsHtml(cached);
          productDetailsDrawer.show();
          return;
        }

        const requestId = ++productDetailsRequest;
        showDetailsMessage(copy.detailsLoading);
        productDetailsDrawer.setAttribute('aria-busy', 'true');
        productDetailsDrawer.show();
        productUrl.searchParams.set('section_id', 'carron-product-details');

        try {
          const response = await fetch(productUrl, {
            credentials: 'same-origin',
            headers: { Accept: 'text/html' },
          });
          if (!response.ok) throw new Error('product_details_failed');
          const documentHtml = new DOMParser().parseFromString(await response.text(), 'text/html');
          const section = documentHtml.getElementById('shopify-section-carron-product-details');
          if (!section?.querySelector('[data-product-details-ready]')) {
            throw new Error('product_details_empty');
          }
          const html = section.innerHTML;
          productDetailsCache.set(cacheKey, html);
          if (requestId === productDetailsRequest) showDetailsHtml(html);
        } catch (_error) {
          if (requestId === productDetailsRequest) showDetailsMessage(copy.detailsUnavailable);
        } finally {
          if (requestId === productDetailsRequest) {
            productDetailsDrawer.removeAttribute('aria-busy');
          }
        }
      };

      root.querySelectorAll('[data-product-details-open]').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          openProductDetails(button);
        });
      });

      const selectedItems = () =>
        Object.entries(basket)
          .filter(([, item]) => Number.isInteger(item.quantity) && item.quantity > 0)
          .map(([variantId, item]) => ({ variantId, quantity: item.quantity }))
          .sort((a, b) => a.variantId.localeCompare(b.variantId));

      const basketFingerprint = () => JSON.stringify(selectedItems());

      const persistLocalBasket = (updatedAt = new Date().toISOString()) => {
        if (isInStock) return true;
        try {
          localStorage.setItem(
            basketStorageKey,
            JSON.stringify({ version: 2, updatedAt, basket }),
          );
          localBasketUpdatedAt = Date.parse(updatedAt) || Date.now();
          localBasketHasTimestamp = true;
          return true;
        } catch (_error) {
          setSavedStatus(copy.saveUnavailable, 'error');
          return false;
        }
      };

      const syncBasket = async () => {
        if (isInStock) return true;
        if (basketSyncing) {
          basketSyncPending = true;
          return false;
        }
        basketSyncing = true;
        let synced = false;
        try {
          const response = await fetch(root.dataset.basketUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: selectedItems(),
              digest: basketDigest,
              locale: root.dataset.locale?.toLowerCase().startsWith('fr') ? 'fr' : 'en',
            }),
          });
          const payload = await response.json().catch(() => null);
          if (response.status === 409 && payload?.error === 'basket_conflict') {
            basketRequestCache.delete(basketRequestKey);
            basketSyncReady = false;
            basketSyncPending = false;
            setSavedStatus(copy.saveConflict, 'error');
            return false;
          }
          if (!response.ok || !payload?.ok || !payload.basket) throw new Error('save_failed');
          basketDigest = payload.basket.digest;
          basketRequestCache.set(basketRequestKey, Promise.resolve(payload.basket));
          persistLocalBasket(payload.basket.updatedAt || new Date().toISOString());
          setSavedStatus(copy.savedAccount, 'saved');
          synced = true;
        } catch (_error) {
          setSavedStatus(copy.saveUnavailable, 'error');
        } finally {
          basketSyncing = false;
          if (basketSyncReady && basketSyncPending) {
            basketSyncPending = false;
            setSavedStatus(copy.savingAccount, 'saving');
            syncBasket();
          }
        }
        return synced;
      };

      const saveBasket = () => {
        if (isInStock) return;
        persistLocalBasket();
        if (!basketSyncReady) return;
        setSavedStatus(copy.savingAccount, 'saving');
        window.clearTimeout(basketSaveTimer);
        basketSaveTimer = window.setTimeout(syncBasket, 800);
      };

      const estimatedTotal = () => {
        if (!pricing) return 0;
        if (isInStock) {
          return roundMoney(
            Object.values(basket).reduce(
              (sum, item) => sum + (Number.isFinite(item.finalLinePrice) ? item.finalLinePrice : 0),
              0,
            ) / 100,
          );
        }
        return roundMoney(
          selectedItems().reduce((sum, item) => {
            const variant = priceByVariant.get(item.variantId);
            if (!variant) return sum;
            return (
              sum +
              roundMoney(
                variant.wholesaleUnitPrice * item.quantity,
              )
            );
          }, 0),
        );
      };

      const setFeedback = (message, isError = false) => {
        feedback.textContent = message || '';
        feedback.dataset.error = isError ? 'true' : 'false';
      };

      const setBusy = (busy) => {
        const disabled = busy || locked;
        const minimum = isInStock
          ? inStockOrderMinimum()
          : pricing?.preorderMinimumEur || 0;
        submitButton.disabled =
          disabled ||
          selectedItems().length === 0 ||
          estimatedTotal() < minimum ||
          cartHasPriceMismatch ||
          cartHasUnsupportedItems;
        variantRows.forEach((row) => {
          const rowVariant = priceByVariant.get(row.dataset.variantId);
          const unavailable = isInStock && (rowVariant?.inventoryQuantity || 0) <= 0;
          const priceUnavailable =
            isInStock && !Number.isFinite(rowVariant?.localWholesaleUnitPrice);
          row.querySelectorAll('[data-quantity-decrease], [data-quantity-input], [data-quantity-increase]').forEach((control) => {
            control.disabled = disabled || unavailable || priceUnavailable || !rowVariant;
          });
          const currentQuantity = basket[row.dataset.variantId]?.quantity || 0;
          const decrease = row.querySelector('[data-quantity-decrease]');
          const increase = row.querySelector('[data-quantity-increase]');
          if (decrease) decrease.disabled ||= currentQuantity <= 0;
          if (increase && isInStock) {
            increase.disabled ||= currentQuantity >= (rowVariant?.inventoryQuantity || 0);
          }
        });
        basketElement.querySelectorAll('button').forEach((control) => {
          control.disabled = disabled;
        });
        clearButton.disabled = disabled || selectedItems().length === 0;
        if (rrpAcknowledgement) rrpAcknowledgement.disabled = disabled;
      };

      const renderBasket = () => {
        basketElement.replaceChildren();
        const items = selectedItems();
        if (items.length === 0) {
          const empty = document.createElement('p');
          empty.textContent = copy.empty;
          basketElement.append(empty);
        } else {
          items.forEach((item) => {
            const stored = basket[item.variantId] || {};
            const variant = priceByVariant.get(item.variantId);
            const line = document.createElement('div');
            line.className = 'carron-preorder__basket-item';
            const imageUrl = stored.imageUrl || variant?.variantImageUrl || variant?.productImageUrl || '';
            if (imageUrl) {
              const imageButton = document.createElement('button');
              imageButton.type = 'button';
              imageButton.className = 'carron-preorder__basket-image';
              const image = document.createElement('img');
              image.src = imageUrl;
              image.alt = stored.imageAlt || stored.productTitle || variant?.productTitle || '';
              image.loading = 'lazy';
              imageButton.append(image);
              imageButton.addEventListener('click', () => openImage(imageUrl, image.alt));
              line.append(imageButton);
            } else {
              const imagePlaceholder = document.createElement('span');
              imagePlaceholder.className = 'carron-preorder__basket-image';
              imagePlaceholder.setAttribute('aria-hidden', 'true');
              line.append(imagePlaceholder);
            }
            const productTitle = stored.productTitle || variant?.productTitle || '';
            const variantTitle = stored.variantTitle || variant?.variantTitle || '';
            const label = document.createElement('span');
            const titleText = `${productTitle}${variantTitle && variantTitle !== productTitle && variantTitle !== 'Default Title' ? ` · ${variantTitle}` : ''}`;
            const displayedUnitPrice = isInStock
              ? stored.finalPrice / 100
              : variant?.wholesaleUnitPrice;
            const displayedLinePrice = isInStock
              ? stored.finalLinePrice / 100
              : roundMoney((displayedUnitPrice || 0) * item.quantity);
            if (Number.isFinite(displayedUnitPrice) && Number.isFinite(displayedLinePrice)) {
              const name = document.createElement('strong');
              name.textContent = titleText;
              const detail = document.createElement('small');
              detail.className = 'carron-preorder__basket-detail';
              detail.textContent = `${item.quantity} × ${money(displayedUnitPrice)} · ${money(displayedLinePrice)}`;
              label.append(name, detail);
            } else {
              label.textContent = `${titleText} · ${item.quantity}`;
            }
            if (isInStock && stored.validationStatus) {
              const priceStatus = document.createElement('span');
              if (stored.validationStatus === 'outside_catalogue') {
                priceStatus.className = 'carron-preorder__basket-price-status carron-preorder__basket-price-status--standard';
                priceStatus.textContent = copy.cartOutsideCatalogueWarning;
              } else if (stored.validationStatus !== 'unverifiable') {
                priceStatus.className = 'carron-preorder__basket-price-status carron-preorder__basket-price-status--professional';
                priceStatus.textContent = copy.cartProfessionalPrice;
                bindPriceStatusTooltip(priceStatus, copy.cartProfessionalPriceTooltip);
              }
              if (priceStatus.textContent) {
                const detail = label.querySelector('.carron-preorder__basket-detail');
                (detail || label).append(priceStatus);
              }
            }
            const remove = document.createElement('button');
            remove.type = 'button';
            remove.className = 'carron-preorder__basket-remove';
            remove.textContent = copy.remove;
            remove.addEventListener('click', () => updateQuantity(item.variantId, 0));
            line.append(label, remove);
            basketElement.append(line);
          });
        }

        const estimated = estimatedTotal();
        setDisplayedTotal(estimated);
        const minimum = isInStock
          ? inStockOrderMinimum()
          : pricing?.preorderMinimumEur || 0;
        const minimumComparableTotal = estimatedTotal();
        const remaining = Math.max(0, minimum - minimumComparableTotal);
        if (minimumProgress) {
          minimumProgress.style.width = `${Math.min(100, minimum > 0 ? (minimumComparableTotal / minimum) * 100 : 0)}%`;
        }
        minimumStatus.textContent = remaining === 0 && items.length > 0
          ? copy.minimumReachedSummary.replace('__MINIMUM__', money(minimum))
          : copy.minimumRemaining
              .replace('__MINIMUM__', money(minimum))
              .replace('__REMAINING__', money(remaining));
        minimumStatus.dataset.met = remaining === 0 && items.length > 0 ? 'true' : 'false';
        if (statusMirror) statusMirror.textContent = minimumStatus.textContent;

        const unitsByProduct = new Map();
        items.forEach((item) => {
          const productId = priceByVariant.get(item.variantId)?.productId;
          if (!productId) return;
          unitsByProduct.set(productId, (unitsByProduct.get(productId) || 0) + item.quantity);
        });
        productRows.forEach((productRow) => {
          const productUnits = unitsByProduct.get(productRow.dataset.productId) || 0;
          const productUnitsElement = productRow.querySelector('[data-product-units]');
          const productUnitsCopy = isInStock
            ? productUnits === 1
              ? copy.instockProductUnitsOne
              : copy.instockProductUnitsOther
            : productUnits === 1
              ? copy.preorderProductUnitsOne
              : copy.preorderProductUnitsOther;
          productUnitsElement.textContent =
            productUnits > 0
              ? productUnitsCopy.replace('__COUNT__', String(productUnits))
              : '';
          if (productUnits > 0) productRow.open = true;
        });
        setBusy(false);
      };

      const updateQuantity = async (variantId, rawQuantity) => {
        const variant = priceByVariant.get(variantId);
        if (!variant) {
          const existing = basket[variantId];
          const quantity = Math.max(0, Number.parseInt(rawQuantity, 10) || 0);
          if (!isInStock || !existing || quantity !== 0) return;
          setBusy(true);
          setFeedback('');
          try {
            const sections = prepareCartSections();
            const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
              },
              body: JSON.stringify({
                id: existing.key || variantId.split('/').pop(),
                quantity: 0,
                sections: sections.join(','),
                sections_url: window.location.pathname,
              }),
            });
            const updatedCart = await response.json().catch(() => null);
            if (!response.ok) throw new Error('cart_remove_failed');
            await loadNativeCart(updatedCart?.sections || {}, 'line-item:change');
          } catch (_error) {
            setFeedback(copy.cartUpdateError, true);
          } finally {
            setBusy(false);
          }
          return;
        }
        const requestedQuantity = Math.max(0, Number.parseInt(rawQuantity, 10) || 0);
        let quantity = Math.min(9999, requestedQuantity);
        if (isInStock) {
          const row = variantRows.find((item) => item.dataset.variantId === variantId);
          const existing = basket[variantId];
          const availableQuantity = Math.max(0, variant.inventoryQuantity || 0);
          if (requestedQuantity > availableQuantity) {
            const currentQuantity = existing?.quantity || 0;
            if (row) {
              row.querySelector('[data-quantity-input]').value = String(currentQuantity);
            }
            setFeedback(
              (availableQuantity === 1
                ? copy.quantityExceedsStockOne
                : copy.quantityExceedsStockOther)
                .replace('__AVAILABLE__', String(availableQuantity))
                .replace('__CURRENT__', String(currentQuantity)),
              true,
            );
            return;
          }
          if (!existing && quantity === 0) return;
          if (row) row.querySelector('[data-quantity-input]').value = String(quantity);
          setBusy(true);
          setFeedback('');
          let cartErrorMessage = copy.cartUpdateError;
          try {
            const numericId = variantId.split('/').pop();
            const endpoint = existing ? 'cart/change.js' : 'cart/add.js';
            const sections = prepareCartSections();
            const body = existing
              ? {
                  id: existing.key || numericId,
                  quantity,
                  sections: sections.join(','),
                  sections_url: window.location.pathname,
                }
              : {
                  items: [{ id: Number(numericId), quantity }],
                  sections: sections.join(','),
                  sections_url: window.location.pathname,
                };
            const response = await fetch(`${window.Shopify.routes.root}${endpoint}`, {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
              },
              body: JSON.stringify(body),
            });
            const updatedCart = await response.json().catch(() => null);
            if (!response.ok) {
              cartErrorMessage = updatedCart?.description || updatedCart?.message || copy.cartUpdateError;
              throw new Error('cart_update_failed');
            }
            await loadNativeCart(
              updatedCart?.sections || {},
              existing ? 'line-item:change' : 'variant:add',
            );
          } catch (_error) {
            setFeedback(cartErrorMessage, true);
            if (row) row.querySelector('[data-quantity-input]').value = String(basket[variantId]?.quantity || 0);
          } finally {
            setBusy(false);
          }
          return;
        }
        if (quantity > 0 && quantity < variant.minimumQuantity) quantity = variant.minimumQuantity;
        const row = variantRows.find((item) => item.dataset.variantId === variantId);
        if (quantity === 0) {
          delete basket[variantId];
        } else {
          basket[variantId] = {
            quantity,
            productTitle:
              row?.dataset.productTitle || basket[variantId]?.productTitle || variant.productTitle || '',
            variantTitle:
              row?.dataset.variantTitle || basket[variantId]?.variantTitle || variant.variantTitle || '',
            imageUrl:
              row?.dataset.imageUrl ||
              basket[variantId]?.imageUrl ||
              variant.variantImageUrl ||
              variant.productImageUrl ||
              '',
            imageAlt:
              row?.dataset.imageAlt || basket[variantId]?.imageAlt || variant.productTitle || '',
          };
        }
        if (row) row.querySelector('[data-quantity-input]').value = String(quantity);
        saveBasket();
        setFeedback('');
        renderBasket();
      };

      const renderVariantStock = (row, variant) => {
        if (!isInStock) return;
        const stock = Math.max(0, variant.inventoryQuantity || 0);
        const displayedStock = stock > 40 ? '40+' : String(stock);
        const stockElement = row.querySelector('[data-variant-stock]');
        stockElement.textContent =
          stock > 0
            ? (stock === 1 ? copy.stockUnitsOne : copy.stockUnitsOther).replace(
                '__COUNT__',
                displayedStock,
              )
            : copy.stockUnavailable;
        stockElement.dataset.level = stock === 0 ? 'none' : stock <= 5 ? 'low' : 'available';
        row.querySelector('[data-quantity-input]').max = String(stock);
      };

      const renderRows = () => {
        const minimumPricingByProduct = new Map();
        let hasIndicativePrices = false;
        variantRows.forEach((row) => {
          const variantId = row.dataset.variantId;
          const variant = priceByVariant.get(variantId);
          if (!variant) throw new Error(`Missing catalogue variant ${variantId}`);
          const retailPriceLocalMinor = Number(row.dataset.retailPriceLocalMinor);
          const retailUnitPriceEur = Number(variant.retailUnitPrice);
          const wholesaleUnitPriceEur = Number(variant.wholesaleUnitPrice);
          const wholesaleRatio = wholesaleUnitPriceEur / retailUnitPriceEur;
          const localWholesaleUnitPrice =
            isInStock &&
            Number.isSafeInteger(retailPriceLocalMinor) &&
            retailPriceLocalMinor >= 0 &&
            Number.isFinite(wholesaleRatio) &&
            wholesaleRatio >= 0 &&
            wholesaleRatio <= 1
              ? Math.round(retailPriceLocalMinor * wholesaleRatio) / 100
              : Number.NaN;
          variant.localWholesaleUnitPrice = localWholesaleUnitPrice;
          const currentMinimum = minimumPricingByProduct.get(variant.productId);
          const displayUnitPrice = isInStock
            ? variant.localWholesaleUnitPrice
            : variant.wholesaleUnitPrice;
          const currentDisplayUnitPrice = isInStock
            ? currentMinimum?.localWholesaleUnitPrice
            : currentMinimum?.wholesaleUnitPrice;
          if (
            Number.isFinite(displayUnitPrice) &&
            (currentMinimum === undefined || displayUnitPrice < currentDisplayUnitPrice)
          ) {
            minimumPricingByProduct.set(variant.productId, variant);
          }
          row.querySelector('[data-variant-price]').textContent = Number.isFinite(displayUnitPrice)
            ? money(displayUnitPrice)
            : copy.priceUnavailable;
          const priceStatus = row.querySelector('[data-variant-price-status]');
          if (priceStatus && isInStock) {
            const professionalEligible = variant.professionalEligible !== false;
            priceStatus.hidden = false;
            priceStatus.textContent = professionalEligible
              ? copy.cartProfessionalPrice
              : copy.cartStandardPrice;
            priceStatus.className = professionalEligible
              ? 'carron-preorder__basket-price-status carron-preorder__basket-price-status--professional'
              : 'carron-preorder__basket-price-status carron-preorder__basket-price-status--standard';
            bindPriceStatusTooltip(
              priceStatus,
              professionalEligible
                ? copy.cartProfessionalPriceTooltip
                : copy.cartStandardPriceTooltip,
            );
          }
          const indicativePrice = row.querySelector('[data-variant-indicative-price]');
          const formattedIndicative = approximatePreorderMoney(variant.wholesaleUnitPrice);
          indicativePrice.hidden = !formattedIndicative;
          indicativePrice.textContent = formattedIndicative ? `(≈ ${formattedIndicative})` : '';
          hasIndicativePrices ||= Boolean(formattedIndicative);
          const rrpLine = row.querySelector('[data-variant-rrp]');
          const rrpPrice = row.querySelector('[data-variant-rrp-price]');
          const formattedRrp =
            Number.isFinite(variant.rrpUnitPrice) && variant.rrpCurrency
              ? moneyInCurrency(variant.rrpUnitPrice, variant.rrpCurrency)
              : '';
          rrpLine.hidden = !formattedRrp;
          rrpPrice.textContent = formattedRrp;
          if (isInStock) {
            renderVariantStock(row, variant);
          } else {
            row.querySelector('[data-variant-minimum]').textContent = copy.minimumUnits.replace(
              '__COUNT__',
              String(variant.minimumQuantity),
            );
          }
          if (basket[variantId]) {
            basket[variantId].productTitle = row.dataset.productTitle || variant.productTitle || '';
            basket[variantId].variantTitle = row.dataset.variantTitle || variant.variantTitle || '';
            basket[variantId].imageUrl =
              row.dataset.imageUrl || basket[variantId].imageUrl || variant.productImageUrl || '';
            basket[variantId].imageAlt =
              row.dataset.imageAlt || basket[variantId].imageAlt || variant.productTitle || '';
          }
          row.querySelector('[data-quantity-input]').value = String(basket[variantId]?.quantity || 0);
        });

        productRows.forEach((productRow) => {
          const minimumPricing = minimumPricingByProduct.get(productRow.dataset.productId);
          const fromPrice = productRow.querySelector('[data-product-from-price]');
          if (!Number.isFinite(minimumPricing?.wholesaleUnitPrice)) {
            fromPrice.textContent = copy.priceUnavailable;
            return;
          }
          const formattedIndicative = approximatePreorderMoney(
            minimumPricing.wholesaleUnitPrice,
          );
          const amount = `${money(
            isInStock
              ? minimumPricing.localWholesaleUnitPrice
              : minimumPricing.wholesaleUnitPrice,
          )}${formattedIndicative ? ` (≈ ${formattedIndicative})` : ''}`;
          fromPrice.textContent = copy.fromPrice.replace('__AMOUNT__', amount);
        });
        if (indicativeNote) indicativeNote.hidden = !hasIndicativePrices;
      };

      const refreshStockByProduct = () => {
        stockByProduct.clear();
        priceByVariant.forEach((variant) => {
          if (!stockByProduct.has(variant.productId)) stockByProduct.set(variant.productId, false);
          if ((variant.inventoryQuantity || 0) > 0) stockByProduct.set(variant.productId, true);
        });
      };

      const applyStockFilter = () => {
        if (!isInStock) return;
        productRows.forEach((productRow) => {
          const hasStock = stockByProduct.get(productRow.dataset.productId) === true;
          productRow.querySelector('[data-product-oos]').hidden = hasStock;
          productRow.hidden = !stockByProduct.has(productRow.dataset.productId) || (hideUnavailable && !hasStock);
        });
        variantRows.forEach((row) => {
          const variant = priceByVariant.get(row.dataset.variantId);
          row.hidden = !variant || variant.professionalEligible === false || (hideUnavailable && (variant.inventoryQuantity || 0) <= 0);
        });

        root.querySelectorAll('.carron-preorder__type-section').forEach((section) => {
          const visibleProducts = [...section.querySelectorAll('[data-product-row]')].filter(
            (productRow) => !productRow.hidden,
          );
          section.hidden = visibleProducts.length === 0;
          const typeCount = section.querySelector('[data-type-count]');
          if (typeCount) {
            typeCount.textContent = (visibleProducts.length === 1
              ? copy.productCountOne
              : copy.productCountOther).replace('__COUNT__', String(visibleProducts.length));
          }
        });

        const visiblePageProductIds = [
          ...new Set(
            productRows
              .filter((productRow) => !productRow.hidden)
              .map((productRow) => productRow.dataset.productId),
          ),
        ];
        const allAvailableProductIds = [...stockByProduct.entries()]
          .filter(([, hasStock]) => !hideUnavailable || hasStock)
          .map(([productId]) => productId);
        const hasNativeFilters = Number(root.dataset.activeFilterCount || 0) > 0;
        const hasCompleteProfessionalCatalogue = root.dataset.professionalOnly === 'true';
        const displayedProductCount =
          hasCompleteProfessionalCatalogue && !hasNativeFilters
            ? allAvailableProductIds.length
            : visiblePageProductIds.length;
        if (resultCount) {
          resultCount.textContent = (displayedProductCount === 1
            ? copy.productCountOne
            : copy.productCountOther).replace(
            '__COUNT__',
            String(displayedProductCount),
          );
        }
        if (inStockNoResults) inStockNoResults.hidden = visiblePageProductIds.length > 0;

        root.querySelectorAll('[data-type-filter]').forEach((link) => {
          link.hidden = false;
        });
        renderSearchResults();
      };

      const post = async (url, body) => {
        const response = await fetch(url, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
        const payload = await response.json().catch(() => null);
        return { response, payload };
      };

      const prepareCartSections = () => {
        const sections = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:prepare-bundled-sections', {
            bubbles: true,
            detail: { sections },
          }),
        );
        return sections;
      };

      const wholesaleLinePriceCheck = (item, variant, currency) => {
        const quantity = Number.isSafeInteger(item.quantity) && item.quantity > 0
          ? item.quantity
          : 1;
        const originalLinePrice = Number.isSafeInteger(item.original_line_price)
          ? item.original_line_price
          : Number.isSafeInteger(item.original_price)
            ? item.original_price * quantity
            : Number.NaN;
        const retailUnitPrice = Number(variant.retailUnitPrice);
        const wholesaleUnitPrice = Number(variant.wholesaleUnitPrice);
        const finalLinePrice = Number(item.final_line_price);
        const ratio = wholesaleUnitPrice / retailUnitPrice;
        const comparable =
          Number.isSafeInteger(originalLinePrice) &&
          originalLinePrice >= 0 &&
          Number.isFinite(retailUnitPrice) &&
          retailUnitPrice > 0 &&
          Number.isFinite(wholesaleUnitPrice) &&
          wholesaleUnitPrice >= 0 &&
          Number.isSafeInteger(finalLinePrice) &&
          finalLinePrice >= 0 &&
          Number.isFinite(ratio) &&
          ratio >= 0 &&
          ratio <= 1;
        const expectedFinalLinePrice = comparable
          ? Math.round(originalLinePrice * ratio)
          : null;
        const tolerance = quantity;
        const mismatch =
          expectedFinalLinePrice === null ||
          Math.abs(expectedFinalLinePrice - finalLinePrice) > tolerance;

        return {
          mismatch,
          diagnostic: {
            currency: currency || null,
            variantId: variant.variantId,
            sku: variant.sku || null,
            quantity,
            originalLinePrice: Number.isFinite(originalLinePrice) ? originalLinePrice : null,
            expectedFinalLinePrice,
            finalLinePrice: Number.isFinite(finalLinePrice) ? finalLinePrice : null,
            finalUnitPrice: Number.isFinite(item.final_price) ? item.final_price : null,
            retailUnitPriceEur: Number.isFinite(retailUnitPrice) ? retailUnitPrice : null,
            wholesaleUnitPriceEur: Number.isFinite(wholesaleUnitPrice)
              ? wholesaleUnitPrice
              : null,
            tolerance,
          },
        };
      };

      const cartIssueMessage = (issue) => {
        if (issue.status === 'outside_catalogue') return copy.cartOutsideCatalogueWarning;
        if (issue.status === 'validation_unavailable') {
          return copy.cartValidationUnavailable;
        }
        const product = issue.fallbackTitle || issue.productTitle || copy.productUnavailable;
        if (issue.status === 'unavailable_mtp') {
          return copy.cartUnavailableMtp.replace('__PRODUCT__', product);
        }
        if (issue.status === 'insufficient_mtp_stock') {
          return copy.cartInsufficientMtp
            .replace('__PRODUCT__', product)
            .replace('__AVAILABLE__', String(Math.max(0, issue.availableQuantity || 0)));
        }
        return copy.cartUnverifiable.replace('__PRODUCT__', product);
      };

      const uniqueCartIssues = (issues) => {
        const unique = new Map();
        issues.forEach((issue) => {
          const product = issue.fallbackTitle || issue.productTitle || '';
          const key = `${issue.status}:${product}:${issue.availableQuantity ?? ''}`;
          if (!unique.has(key)) unique.set(key, issue);
        });
        return [...unique.values()];
      };

      const recoverValidatedVariant = (validation) => {
        if (validation.status !== 'eligible') return;
        if (
          !validation.productId ||
          !Number.isFinite(validation.retailUnitPrice) ||
          !Number.isFinite(validation.wholesaleUnitPrice)
        ) return;
        const existing = priceByVariant.get(validation.variantId) || {};
        priceByVariant.set(validation.variantId, {
          ...existing,
          variantId: validation.variantId,
          productId: validation.productId,
          productHandle: validation.productHandle || existing.productHandle || '',
          productTitle: validation.productTitle || existing.productTitle || '',
          productType: existing.productType || '',
          variantTitle: validation.variantTitle || existing.variantTitle || '',
          sku: validation.sku || existing.sku || null,
          retailUnitPrice: validation.retailUnitPrice,
          wholesaleUnitPrice: validation.wholesaleUnitPrice,
          minimumQuantity: existing.minimumQuantity || 1,
          inventoryQuantity: Math.max(0, validation.availableQuantity || 0),
          inventoryPolicy: validation.inventoryPolicy || 'DENY',
          productImageUrl: existing.productImageUrl || null,
          variantImageUrl: existing.variantImageUrl || null,
        });
      };

      const loadNativeCart = async (sections = null, baseEvent = 'line-item:change') => {
        const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });
        const cart = await response.json().catch(() => null);
        if (!response.ok || !cart || !Array.isArray(cart.items)) {
          throw new Error('cart_load_failed');
        }
        let validationByVariant = new Map();
        let validationAvailable = true;
        if (cart.items.length > 0) {
          const validation = await post(root.dataset.cartValidationUrl, {
            items: cart.items.map((item) => ({
              variantId: `gid://shopify/ProductVariant/${item.variant_id}`,
              quantity: item.quantity,
            })),
          });
          if (!validation.response.ok || !validation.payload?.ok || !Array.isArray(validation.payload.items)) {
            validationAvailable = false;
          } else {
            validationByVariant = new Map(
              validation.payload.items.map((item) => [item.variantId, item]),
            );
            validation.payload.items.forEach(recoverValidatedVariant);
          }
        }
        basket = {};
        cartHasPriceMismatch = false;
        cartHasUnsupportedItems = false;
        cartPriceMismatchProducts = [];
        cartValidationIssues = validationAvailable
          ? []
          : [{ status: 'validation_unavailable' }];
        cart.items.forEach((item) => {
          const variantId = `gid://shopify/ProductVariant/${item.variant_id}`;
          const variant = priceByVariant.get(variantId);
          const validation = validationByVariant.get(variantId);
          const validationStatus = validationAvailable
            ? validation?.status || 'unverifiable'
            : 'unverifiable';
          if (
            validationAvailable &&
            validationStatus !== 'eligible'
          ) {
            cartHasUnsupportedItems = true;
            cartValidationIssues.push({
              ...(validation || { status: 'unverifiable' }),
              fallbackTitle: item.product_title || '',
            });
          }
          if (!validationAvailable) cartHasUnsupportedItems = true;
          if (variant && validation?.status === 'eligible') {
            const priceCheck = wholesaleLinePriceCheck(item, variant, cart.currency);
            if (priceCheck.mismatch) {
              cartHasPriceMismatch = true;
              cartPriceMismatchProducts.push(item.product_title || variant.productTitle || '');
              console.warn('[CARRON wholesale] cart price mismatch', priceCheck.diagnostic);
            }
          }
          const existingBasketItem = basket[variantId];
          basket[variantId] = {
            key: existingBasketItem?.key || item.key,
            quantity: (existingBasketItem?.quantity || 0) + item.quantity,
            finalPrice: item.final_price,
            finalLinePrice: (existingBasketItem?.finalLinePrice || 0) + item.final_line_price,
            originalLinePrice: (existingBasketItem?.originalLinePrice || 0) + item.original_line_price,
            productTitle: item.product_title || variant?.productTitle || '',
            variantTitle: item.variant_title || variant?.variantTitle || '',
            imageUrl: item.image || variant?.variantImageUrl || variant?.productImageUrl || '',
            imageAlt: item.product_title || variant?.productTitle || '',
            validationStatus,
          };
        });
        refreshStockByProduct();
        variantRows.forEach((row) => {
          const variant = priceByVariant.get(row.dataset.variantId);
          if (variant) renderVariantStock(row, variant);
          row.querySelector('[data-quantity-input]').value = String(basket[row.dataset.variantId]?.quantity || 0);
        });
        applyStockFilter();
        if (cartHasPriceMismatch) {
          const products = [...new Set(cartPriceMismatchProducts.filter(Boolean))];
          const priceMessage = products.length > 0
            ? products
                .map((product) => copy.cartPriceMismatchProduct.replace('__PRODUCT__', product))
                .join(' ')
            : copy.cartPriceMismatch;
          setFeedback(priceMessage, true);
        } else if (cartHasUnsupportedItems) {
          const issueMessage = uniqueCartIssues(cartValidationIssues)
            .map(cartIssueMessage)
            .join(' ');
          setFeedback(issueMessage, true);

        } else {
          setFeedback('');
        }
        renderBasket();
        if (sections) {
          cart.sections = sections;
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:change', {
              bubbles: true,
              detail: { baseEvent, cart },
            }),
          );
        }
        return cart;
      };

      const submit = async () => {
        const items = selectedItems();
        if (items.length === 0) return;
        if (!rrpAcknowledgement?.checked) {
          rrpAcknowledgement?.setAttribute('aria-invalid', 'true');
          setFeedback(copy.rrpAcknowledgementRequired, true);
          rrpAcknowledgement?.focus();
          return;
        }
        if (isInStock) {
          setBusy(true);
          try {
            await loadNativeCart();
          } catch (_error) {
            setFeedback(copy.cartValidationUnavailable, true);
            setBusy(false);
            return;
          }
          if (selectedItems().length === 0) {
            setBusy(false);
            return;
          }
          if (cartHasPriceMismatch || cartHasUnsupportedItems) return;
          const remaining = Math.max(0, inStockOrderMinimum() - estimatedTotal());
          if (remaining > 0) {
            setFeedback(`${copy.remaining} ${formatInStockMoney(remaining)}`, true);
            root.querySelector('.carron-preorder__summary-card')?.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
            });
            return;
          }
          setBusy(true);
          submitButton.textContent = copy.checkoutProcessing;
          setFeedback('');
          try {
            const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                attributes: {
                  'RRP acknowledgement': `${root.dataset.rrpPolicyVersion}:${root.dataset.locale === 'fr' ? 'fr' : 'en'}`,
                },
              }),
            });
            if (!response.ok) throw new Error('cart_acknowledgement_failed');
            window.location.assign(`${window.Shopify.routes.root}checkout`);
          } catch (_error) {
            setFeedback(copy.cartUpdateError, true);
            submitButton.textContent = submitButton.dataset.label;
            setBusy(false);
          }
          return;
        }
        if (items.length > 250) {
          setFeedback(copy.tooManyLines, true);
          return;
        }
        const fingerprint = basketFingerprint();
        const pending = parseJson(localStorage.getItem(submissionStorageKey) || '{}', {});
        const idempotencyKey =
          pending.fingerprint === fingerprint && pending.idempotencyKey
            ? pending.idempotencyKey
            : crypto.randomUUID();
        localStorage.setItem(submissionStorageKey, JSON.stringify({ fingerprint, idempotencyKey }));
        setBusy(true);
        submitButton.textContent = copy.submitting;
        setFeedback('');
        try {
          const { response, payload } = await post(root.dataset.submitUrl, {
            idempotencyKey,
            items,
            rrpAcknowledgement: {
              acknowledged: true,
              version: root.dataset.rrpPolicyVersion,
              locale: root.dataset.locale === 'fr' ? 'fr' : 'en',
            },
          });
          const result = payload?.result;
          if (result?.status === 'CREATED') {
            locked = true;
            basket = {};
            persistLocalBasket();
            variantRows.forEach((row) => {
              row.querySelector('[data-quantity-input]').value = '0';
            });
            renderBasket();
            setFeedback(copy.created.replace('__NAME__', result.draftOrderName));
            openConfirmation(result.draftOrderName);
            const accountBasketCleared = basketSyncReady ? await syncBasket() : false;
            if (accountBasketCleared) {
              try {
                localStorage.removeItem(submissionStorageKey);
              } catch (_error) {
                setSavedStatus(copy.saveUnavailable, 'error');
              }
            }
            return;
          }
          if (result?.status === 'PROCESSING' || result?.status === 'NEEDS_REVIEW') {
            locked = true;
            setFeedback(copy.pending);
            return;
          }
          if (result?.status === 'MINIMUM_NOT_MET') {
            setDisplayedTotal(result.quote.totalWholesale);
            minimumStatus.textContent = `${copy.remaining} ${money(result.quote.remainingToMinimum)}`;
            minimumStatus.dataset.met = 'false';
            setFeedback(`${copy.remaining} ${money(result.quote.remainingToMinimum)}`, true);
            return;
          }
          if (!response.ok) throw new Error('submit_failed');
          throw new Error('unknown_status');
        } catch (_error) {
          setFeedback(copy.submitError, true);
        } finally {
          submitButton.textContent = submitButton.dataset.label;
          setBusy(false);
        }
      };

      submitButton.dataset.label = submitButton.textContent.trim();
      submitButton.addEventListener('click', submit);
      root.addEventListener('click', (event) => {
        const control = event.target.closest('[data-quantity-decrease], [data-quantity-increase]');
        if (!control || !root.contains(control)) return;
        const row = control.closest('[data-variant-row]');
        const variant = row ? priceByVariant.get(row.dataset.variantId) : null;
        if (!row || !variant) return;
        const current = basket[row.dataset.variantId]?.quantity || 0;
        if (control.matches('[data-quantity-decrease]')) {
          updateQuantity(
            row.dataset.variantId,
            current <= (isInStock ? 1 : variant.minimumQuantity) ? 0 : current - 1,
          );
          return;
        }
        updateQuantity(
          row.dataset.variantId,
          current === 0 ? (isInStock ? 1 : variant.minimumQuantity) : current + 1,
        );
      }, true);
      root.addEventListener('change', (event) => {
        const input = event.target.closest('[data-quantity-input]');
        if (!input || !root.contains(input)) return;
        const row = input.closest('[data-variant-row]');
        if (!row) return;
        updateQuantity(row.dataset.variantId, input.value);
      }, true);
      root.addEventListener('input', (event) => {
        if (!isInStock) return;
        const input = event.target.closest('[data-quantity-input]');
        if (!input || !root.contains(input)) return;
        const row = input.closest('[data-variant-row]');
        const variant = row ? priceByVariant.get(row.dataset.variantId) : null;
        if (!row || !variant) return;
        const requestedQuantity = Math.max(0, Number.parseInt(input.value, 10) || 0);
        const availableQuantity = Math.max(0, variant.inventoryQuantity || 0);
        if (requestedQuantity <= availableQuantity) return;
        const currentQuantity = basket[row.dataset.variantId]?.quantity || 0;
        input.value = String(currentQuantity);
        setFeedback(
          (availableQuantity === 1
            ? copy.quantityExceedsStockOne
            : copy.quantityExceedsStockOther)
            .replace('__AVAILABLE__', String(availableQuantity))
            .replace('__CURRENT__', String(currentQuantity)),
          true,
        );
      }, true);
      rrpAcknowledgement?.addEventListener('change', () => {
        rrpAcknowledgement.removeAttribute('aria-invalid');
        if (feedback.textContent === copy.rrpAcknowledgementRequired) setFeedback('');
      });
      basketElement.addEventListener('scroll', hideBasketPriceTooltip, { passive: true });
      window.addEventListener('resize', hideBasketPriceTooltip, { passive: true });
      clearButton.addEventListener('click', () => {
        if (isInStock) {
          const updates = Object.fromEntries(
            selectedItems().map((item) => [item.variantId.split('/').pop(), 0]),
          );
          const sections = prepareCartSections();
          setBusy(true);
          fetch(`${window.Shopify.routes.root}cart/update.js`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({
              updates,
              sections: sections.join(','),
              sections_url: window.location.pathname,
            }),
          })
            .then(async (response) => {
              if (!response.ok) throw new Error('cart_clear_failed');
              const updatedCart = await response.json().catch(() => null);
              return loadNativeCart(updatedCart?.sections || {}, 'line-item:change');
            })
            .catch(() => setFeedback(copy.cartUpdateError, true))
            .finally(() => setBusy(false));
          return;
        }
        basket = {};
        saveBasket();
        variantRows.forEach((row) => {
          row.querySelector('[data-quantity-input]').value = '0';
        });
        setFeedback('');
        renderBasket();
      });

      if (isInStock) {
        document.addEventListener(
          'click',
          (event) => {
            const checkout = event.target.closest('a[href*="/checkout"], button[name="checkout"], input[name="checkout"]');
            if (!checkout || root.contains(checkout)) return;
            event.preventDefault();
            event.stopImmediatePropagation();
            submit();
          },
          true,
        );
      }

      const revealSearchTarget = (product, behavior = 'smooth') => {
        if (!product || !root.contains(product)) return;
        product.open = true;
        product.classList.remove('is-search-target');
        window.requestAnimationFrame(() => {
          product.classList.add('is-search-target');
          const summary = product.querySelector(':scope > summary');
          (summary || product).scrollIntoView({ block: 'center', behavior });
        });
        window.clearTimeout(searchTargetTimer);
        searchTargetTimer = window.setTimeout(() => {
          product.classList.remove('is-search-target');
        }, 2700);
      };

      const revealHashTarget = (behavior = 'auto') => {
        if (!window.location.hash.startsWith('#wholesale-product-')) return;
        revealSearchTarget(document.getElementById(window.location.hash.slice(1)), behavior);
      };

      const revealAlertTarget = () => {
        if (!alertVariantId) return;
        if (!alertTargetRow) {
          setFeedback(copy.searchNoResults, true);
          return;
        }
        if (alertTargetRow.hidden) {
          hideUnavailable = false;
          const toggle = proAlerts?.querySelector('[data-hide-unavailable]');
          if (toggle) {
            toggle.checked = true;
            toggle.dispatchEvent(new Event('change', { bubbles: true }));
          }
          applyStockFilter();
        }
        const product = alertTargetRow.closest('[data-product-row]');
        revealSearchTarget(product, 'auto');
        window.requestAnimationFrame(() => {
          alertTargetRow.classList.add('is-alert-target');
          alertTargetRow.tabIndex = -1;
          alertTargetRow.focus({ preventScroll: true });
          alertTargetRow.scrollIntoView({ block: 'center', behavior: 'auto' });
        });
      };

      const renderSearchResults = () => {
        searchResults.replaceChildren();
        const query = normalizeSearch(search.value.trim(), root.dataset.locale);
        if (query.length < 2 || priceByVariant.size === 0) {
          searchResults.hidden = true;
          return;
        }
        const queryTokens = query.split(/\s+/).filter(Boolean);

        const groups = new Map();
        priceByVariant.forEach((variant) => {
          if (isInStock && hideUnavailable && (variant.inventoryQuantity || 0) <= 0) return;
          if (!isInStock && stockByProduct.get(variant.productId) !== true) return;
          const haystack = normalizeSearch(
            [
              variant.productTitle,
              variant.productType,
              variant.variantTitle,
              variant.sku,
            ].join(' '),
            root.dataset.locale,
          );
          if (!queryTokens.every((token) => haystack.includes(token))) return;
          const key = variant.productId;
          if (!groups.has(key)) {
            groups.set(key, { variant, matchingVariants: [] });
          }
          const group = groups.get(key);
          if (group.matchingVariants.length < 3) group.matchingVariants.push(variant);
        });

        const matches = [...groups.values()];
        if (matches.length === 0) {
          const empty = document.createElement('p');
          empty.textContent = copy.searchNoResults;
          searchResults.append(empty);
          searchResults.hidden = false;
          return;
        }

        const count = document.createElement('p');
        count.textContent = copy.searchResults.replace('__COUNT__', String(matches.length));
        searchResults.append(count);

        matches.slice(0, 12).forEach(({ variant, matchingVariants }) => {
          const link = document.createElement('a');
          link.className = 'carron-preorder__search-result';
          const target = new URL(root.dataset.collectionUrl, window.location.origin);
          if (variant.productPage > 1) target.searchParams.set('page', String(variant.productPage));
          target.hash = `wholesale-product-${variant.productId.split('/').pop()}`;
          link.href = target.toString();
          link.addEventListener('click', (event) => {
            const product = root.querySelector(target.hash);
            if (!product) return;
            event.preventDefault();
            searchResults.hidden = true;
            history.replaceState({}, '', target.hash);
            revealSearchTarget(product);
          });

          if (variant.variantImageUrl || variant.productImageUrl) {
            const image = document.createElement('img');
            image.src = variant.variantImageUrl || variant.productImageUrl;
            image.alt = '';
            image.loading = 'lazy';
            link.append(image);
          } else {
            const placeholder = document.createElement('span');
            placeholder.className = 'carron-preorder__search-result-image';
            placeholder.setAttribute('aria-hidden', 'true');
            link.append(placeholder);
          }

          const label = document.createElement('span');
          const title = document.createElement('strong');
          title.textContent = variant.productTitle;
          const details = document.createElement('span');
          const matchingLabels = matchingVariants
            .map((item) =>
              [item.variantTitle === 'Default Title' ? '' : item.variantTitle, item.sku]
                .filter(Boolean)
                .join(' · '),
            )
            .filter(Boolean);
          details.textContent = matchingLabels.join(' / ') || variant.productType || '';
          if (stockByProduct.get(variant.productId) !== true) {
            details.textContent = [details.textContent, copy.productUnavailable]
              .filter(Boolean)
              .join(' · ');
          }
          label.append(title, details);
          link.append(label);
          searchResults.append(link);
        });
        searchResults.hidden = false;
      };

      search.addEventListener('input', renderSearchResults);
      root.addEventListener('carron:stock-visibility', (event) => {
        hideUnavailable = event.detail.hideUnavailable;
        applyStockFilter();
      });
      searchClear?.addEventListener('click', () => {
        search.value = '';
        search.dispatchEvent(new Event('input', { bubbles: true }));
        search.focus();
      });

      root.querySelectorAll('[data-type-filter]').forEach((link) => {
        link.addEventListener('click', (event) => {
          event.preventDefault();
          const url = new URL(window.location.href);
          const parameter = link.dataset.typeFilterParam;
          url.searchParams.delete(parameter);
          if (link.dataset.typeFilterValue) {
            url.searchParams.append(parameter, link.dataset.typeFilterValue);
          }
          url.searchParams.delete('page');
          url.searchParams.set('section_id', root.dataset.sectionId);
          root.dispatchEvent(
            new CustomEvent('facet:update', {
              bubbles: true,
              detail: { url },
            }),
          );
        });
      });

      root.querySelectorAll('.carron-preorder__filter-form--desktop .carron-preorder__facet').forEach(
        (facet) => {
          facet.addEventListener('toggle', () => {
            if (!facet.open) return;
            root
              .querySelectorAll('.carron-preorder__filter-form--desktop .carron-preorder__facet')
              .forEach((otherFacet) => {
                if (otherFacet !== facet) otherFacet.open = false;
              });
          });
        },
      );
      const filterForm = root.querySelector('.carron-preorder__filter-form--desktop');
      filterForm?.addEventListener('change', () => closeDesktopFacets(root), true);
      root.addEventListener('click', (event) => {
        if (!search.contains(event.target) && !searchResults.contains(event.target)) {
          searchResults.hidden = true;
        }
        if (event.target.closest('.carron-preorder__facet')) return;
        root
          .querySelectorAll('.carron-preorder__filter-form--desktop .carron-preorder__facet[open]')
          .forEach((facet) => {
            facet.open = false;
          });
      });
      root.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        searchResults.hidden = true;
        root
          .querySelectorAll('.carron-preorder__filter-form--desktop .carron-preorder__facet[open]')
          .forEach((facet) => {
            facet.open = false;
          });
      });
      root.querySelector('[data-mobile-filter-close]')?.addEventListener('click', (event) => {
        event.currentTarget.closest('.carron-preorder__filters-mobile')?.removeAttribute('open');
      });

      const catalogueRequestUrl = new URL(root.dataset.catalogueUrl, window.location.origin);
      catalogueRequestUrl.searchParams.set('country', root.dataset.country || 'FR');
      if (isInStock && !locateAlertTarget) {
        const pageProductIds = [
          ...new Set(
            productRows.map((productRow) => (productRow.dataset.productId || '').split('/').pop()),
          ),
        ].filter((productId) => /^\d+$/.test(productId));
        catalogueRequestUrl.searchParams.set('product_ids', pageProductIds.join(','));
      }
      const catalogueRequestKey = catalogueRequestUrl.toString();
      const fetchCatalogue = () =>
        fetch(catalogueRequestUrl, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        }).then(async (response) => {
          const payload = await response.json().catch(() => null);
          if (!response.ok || !payload?.ok || !payload.pricing || !Array.isArray(payload.variants)) {
            throw new Error('catalogue_failed');
          }
          return payload;
        });
      const catalogueRequest = isInStock
        ? fetchCatalogue()
        : cachedRequest(catalogueRequestCache, catalogueRequestKey, fetchCatalogue);
      const basketRequest = isInStock
        ? Promise.resolve(null)
        : cachedRequest(basketRequestCache, basketRequestKey, () =>
            fetch(basketRequestUrl, {
              credentials: 'same-origin',
              headers: { Accept: 'application/json' },
            }).then(async (response) => {
              const payload = await response.json().catch(() => null);
              return response.ok && payload?.ok && payload.basket ? payload.basket : null;
            }),
          ).catch(() => null);

      Promise.all([catalogueRequest, basketRequest])
        .then(async ([payload, accountBasket]) => {
          if (locateAlertTarget) {
            const target = payload.variants.find((variant) => variant.variantId === alertVariantId);
            const targetUrl = window.CarronAlertLinks.pageUrl(initialUrl.href, root.dataset.collectionUrl, target);
            if (targetUrl) { window.location.replace(targetUrl); return; }
          }
          if (isInStock) payload.variants = payload.variants.filter((variant) => variant.professionalEligible !== false);
          pricing = payload.pricing;
          payload.variants.forEach((variant) => {
            priceByVariant.set(variant.variantId, variant);
          });
          refreshStockByProduct();
          if (pricelistLink) {
            pricelistLink.hidden = !payload.variants.some(
              (variant) => Number.isFinite(variant.rrpUnitPrice) && variant.rrpCurrency,
            );
          }

          if (isInStock) {
            renderRows();
            applyStockFilter();
            if (proAlerts) {
              customElements.whenDefined('carron-pro-stock-alerts').then(() => {
                proAlerts.setVariants(payload.variants);
              });
            }
            const localizedMinimum = inStockOrderMinimum();
            conditionMinimums.forEach((conditionMinimum) => {
              conditionMinimum.textContent = formatInStockMoney(localizedMinimum);
            });
            status.hidden = true;
            content.hidden = false;
            root.dataset.hydrating = 'false';
            root.setAttribute('aria-busy', 'false');
            renderSearchResults();
            revealHashTarget();
            revealAlertTarget();
            loadNativeCart()
              .then(() => {
                if (!reviewCheckout) return;
                setFeedback(copy.reviewCheckout);
                window.requestAnimationFrame(() => {
                  root.querySelector('.carron-preorder__summary-card')?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                  });
                });
              })
              .catch(() => setFeedback(copy.cartValidationUnavailable, true));
            return;
          }

          if (accountBasket) {
            basketDigest = accountBasket.digest;
            const serverUpdatedAt = Date.parse(accountBasket.updatedAt || '') || 0;
            const legacyLocalWins =
              !localBasketHasTimestamp && serverUpdatedAt === 0 && selectedItems().length > 0;
            const localWins =
              (localBasketHasTimestamp && localBasketUpdatedAt > serverUpdatedAt) ||
              legacyLocalWins;
            if (!localWins) {
              basket = {};
              accountBasket.items.forEach((item) => {
                const variant = priceByVariant.get(item.variantId);
                if (!variant) return;
                basket[item.variantId] = {
                  quantity: item.quantity,
                  productTitle: variant.productTitle || '',
                  variantTitle: variant.variantTitle || '',
                  imageUrl: variant.variantImageUrl || variant.productImageUrl || '',
                  imageAlt: variant.variantTitle || variant.productTitle || '',
                };
              });
              persistLocalBasket(accountBasket.updatedAt || new Date().toISOString());
              setSavedStatus(copy.savedAccount, 'saved');
            }
            basketSyncReady = true;
            if (localWins) saveBasket();
          } else {
            setSavedStatus(copy.saveUnavailable, 'error');
          }

          Object.keys(basket).forEach((variantId) => {
            if (!priceByVariant.has(variantId)) delete basket[variantId];
          });
          renderRows();
          persistLocalBasket(
            localBasketUpdatedAt > 0
              ? new Date(localBasketUpdatedAt).toISOString()
              : new Date().toISOString(),
          );
          conditionMinimums.forEach((conditionMinimum) => {
            conditionMinimum.textContent = formatPreorderEur(pricing.preorderMinimumEur);
          });
          status.hidden = true;
          content.hidden = false;
          root.dataset.hydrating = 'false';
          root.setAttribute('aria-busy', 'false');
          renderBasket();
          renderSearchResults();
          revealHashTarget();
        })
        .catch((_error) => {
          status.textContent = copy.unavailable;
          status.dataset.error = 'true';
          content.hidden = true;
          root.dataset.hydrating = 'false';
          root.setAttribute('aria-busy', 'false');
          variantRows.forEach((row) => {
            row.querySelector('[data-variant-price]').textContent = copy.priceUnavailable;
          });
        });
    };

    const initializeAll = (container = document) => {
      container.querySelectorAll('[data-wholesale-preorder]').forEach(initialize);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carron-wholesale-resources"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (root.dataset.mounted === 'true') return;
      root.dataset.mounted = 'true';
      const inStockMinimum = root.querySelector('[data-instock-minimum]');
      const preorderMinimum = root.querySelector('[data-preorder-minimum]');
      const error = root.querySelector('[data-profile-error]');
      const money = (value) =>
        new Intl.NumberFormat(root.dataset.locale || 'en', {
          style: 'currency',
          currency: 'EUR',
        }).format(value);

      fetch(root.dataset.profileUrl, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      })
        .then(async (response) => {
          const payload = await response.json().catch(() => null);
          if (
            !response.ok ||
            !payload?.ok ||
            !Number.isFinite(payload.pricing?.orderMinimumEur) ||
            !Number.isFinite(payload.pricing?.preorderMinimumEur)
          ) {
            throw new Error('profile_unavailable');
          }
          inStockMinimum.textContent = money(payload.pricing.orderMinimumEur);
          preorderMinimum.textContent = money(payload.pricing.preorderMinimumEur);
        })
        .catch(() => {
          inStockMinimum.textContent = '-';
          preorderMinimum.textContent = '-';
          error.hidden = false;
        });
    };

    const initializeAll = (container = document) => {
      container.querySelectorAll('[data-wholesale-resources]').forEach(initialize);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
